import { DASH } from 'shared/constants';
import { FieldDataInformation } from 'shared/types';

export const createFieldFormatPercentageFunction =
  (precision = 2) =>
  (data?: FieldDataInformation): string => {
    if (!data?.value) {
      return DASH;
    }

    if (typeof data.value === 'string') {
      return data.value;
    }

    return `${data.value.toFixed(precision)}%`;
  };
